import React from "react"
import * as styles from './../BoxList.module.scss'
import { Icon } from '@iconify/react';

const BoxListItem = ({item}) => {
   
    return(  
        <li className={`${styles.boxList_item}` }>
            {item.icon && 
                <Icon icon={item.icon} className={styles.boxItem_icon} inline={true} width="30" height="30" vAlign='center'/>}
            {item.title ? item.title : item}
        </li>          
    )
}

export default BoxListItem